// extracted by mini-css-extract-plugin
export var standaloneTable = "_g2-0";
export var standaloneTableWithBodyFill = "_g2-1";
export var withExtraHeader = "_g2-2";